"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = void 0;
const formatPrice = (price) => {
    if (price && price % 1 != 0) {
        let str = price.toFixed(3);
        let strArr = str.split("");
        strArr.reverse();
        if (strArr[1] === "0" && strArr[0] !== "0")
            return str;
        strArr.shift();
        strArr.reverse();
        return parseFloat(strArr.join(""));
    }
    return price;
};
exports.formatPrice = formatPrice;
